import {OrpyxUserRoleAssignModalMeta} from "./orpyx-user-role-assign-modal.interface";

export const onOrpyxUserRoleAssignModalLoaded = (props: OrpyxUserRoleAssignModalMeta) => () => {
    if (!props.isOrpyxRolesLoaded) {
        props.loadOrpyxRoles();
    }
}
